/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css"
import "vuetify/styles"

// Composables
import { createVuetify } from "vuetify"

const defaultStyle = {
  density: "compact",
  //variant: "solo-filled",
  color: "primary",
  hideDetails:"auto"
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: "#a76fcc",
          secondary: "#7394ff",
          accent: "#ffb34a",
        },
      },
    },
  },
  defaults: {
    VBtn: {
      ...defaultStyle,
      capitalize: false,
      density: "default",
      variant: "flat"
    },
    VTextField: {
      ...defaultStyle,
    },
    VTextarea: {
      ...defaultStyle,
    },
    VCombobox: {
      ...defaultStyle,
    },
    VCheckbox: {
      ...defaultStyle,
    },
    VSelect: {
      ...defaultStyle,
    },
    VChip: {
      ...defaultStyle,
      density: "default",
      variant: "flat"
    },
    VAutocomplete: {
      ...defaultStyle
    },
    VCol: {
      cols: "12",
      class: "pa-1"
    },
    VSwitch: {
      ...defaultStyle
    }

  },
})
